/**
 * @generated SignedSource<<44758e30b06e2152a521fd91355dabb8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductActionEnum = "product_activate" | "product_deactivate" | "product_delete" | "product_update" | "%future added value";
export type ProductActivateInput = {
  id: string;
};
export type ProductId_productActivateMutation$variables = {
  input: ProductActivateInput;
};
export type ProductId_productActivateMutation$data = {
  readonly productActivate: {
    readonly actions: ReadonlyArray<ProductActionEnum>;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProductStatusLabel_product">;
  };
};
export type ProductId_productActivateMutation = {
  response: ProductId_productActivateMutation$data;
  variables: ProductId_productActivateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actions",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductId_productActivateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "productActivate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductStatusLabel_product"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductId_productActivateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "productActivate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7820dce39b3cc1e505305b9bbdb8ea7d",
    "id": null,
    "metadata": {},
    "name": "ProductId_productActivateMutation",
    "operationKind": "mutation",
    "text": "mutation ProductId_productActivateMutation(\n  $input: ProductActivateInput!\n) {\n  productActivate(input: $input) {\n    id\n    actions\n    ...ProductStatusLabel_product\n  }\n}\n\nfragment ProductStatusLabel_product on Product {\n  status\n}\n"
  }
};
})();

(node as any).hash = "e00d85f9bb968c58dd90a983280ebf1d";

export default node;
